import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, as: Tag = "h1", className = "", delay = 0.15, testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.13 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "", light = false }) => (
  <p className={`font-mono-ui text-xs uppercase tracking-[0.22em] ${light ? "text-[#E9A88F]" : "text-[#A9533A]"} ${className}`}>
    {children}
  </p>
);
